import React, { useState, useEffect } from 'react';
import '../../css/onboardingLinkCardSteps.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';
import { isValidPhoneNumber, useMobileMediaQuery, useTabletMediaQuery } from '../../utils';
import { useDispatch, useSelector } from 'react-redux';
import { setSessionId, setCookieId, setNAssocia } from '../../features/onboardingData/onboardingUserData';
import imgAddMbWay from '../../assets/img/onboarding/desktop/img-acumule-saldo-codigo-referal.jpg';
import imgAddMbWayTablet from '../../assets/img/onboarding/tablet/img-acumule-saldo-codigo-referal.jpg'
import imgAddMbWayMobile from '../../assets/img/onboarding/mobile/img-acumule-saldo-codigo-referal.jpg'
import { AiOutlineStop } from "react-icons/ai";
import CustomButton from '../../components/CustomButton';
import Heading from '../../components/Heading';
import GifAnim from '../../components/GifAnim';
import { errorHandling } from '../../utils';

function OnboardingLinkCardStepMbWay() {

    const [isLoading, setIsLoading] = useState(true);
    const [phone, setPhone] = useState('');
    const [isStartingLoadingDots, setIsStartingLoadingDots] = useState(false)
    const navigate = useNavigate();
    const isMobile = useMobileMediaQuery();
    const isTablet = useTabletMediaQuery();
    const isSessionId = useSelector((state) => state.onboardingUserData.isSessionId);
    const isCookieId = useSelector((state) => state.onboardingUserData.isCookieId);
    const isNAssocia = useSelector((state) => state.onboardingUserData.isNAssocia);
    const dispatch = useDispatch()
    const [isValidPhone, setIsValidPhone] = useState(true); 
    const [isFocused, setIsFocused] =  useState(false);

    useEffect(() => {
        const delay = setTimeout(() => {
        setIsLoading(false); 
        }, 1000); 

        return () => clearTimeout(delay); 
    }, []);

    const handleFocus = () => {
        setIsFocused(true);
    };
    
    const handleBlur = () => {
        setIsFocused(false);
    };

    const handleClickShowConfigModal = () => {
        alert('mbway');
        //getAssociaCarteira();
    };

    const fetchCSRFToken = async () => {
        try {
          const response = await fetch(`${process.env.REACT_APP_DEV_URL}/csrf-token`, {
            credentials: "include",
            mode: 'cors'
          });
          const data = await response.json();
          const csrfToken = data.csrfToken;
    
          return csrfToken;
        } catch (error) {
          errorHandling('CSRF');
        }
    };

    const getAssociaCarteira = async () => {
        setIsStartingLoadingDots(true);
        try {
            const csrfToken = await fetchCSRFToken();
            const response = await fetch(`${process.env.REACT_APP_DEV_URL}/associaCarteira/fetchAssociaCarteira`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': 'PT-PT',
                    'CookieId': `${isCookieId}`,
                    'SessionId': `${isSessionId}`,
                    'ClientId': '',
                    "xsrf-token": csrfToken,
                },
                credentials: "include",
                mode: "cors",
                body: JSON.stringify({ ntelefone: phone, birthDate: ' ' }),
            });
            if (response.ok === false) {
                errorHandling(response.status);
                return;
            }
            const result = await response.json();
            if (result.error.erroMsg === 'Success') {
                setIsValidPhone(true);
                setIsStartingLoadingDots(false);
                dispatch(setNAssocia(result.nAssocia))
                hadleNav();
            } else {
                setIsValidPhone(false);
                setIsStartingLoadingDots(false);
            }
        } catch (error) {
            setIsStartingLoadingDots(false);
            if (!navigator.onLine) {
                errorHandling('NoInternet');
            } else if (error instanceof TypeError && error.message === "Failed to fetch") {
            errorHandling('CORS');
            } else {
            errorHandling();
            }
        }
    }

    const hadleNav = () => {
        navigate("/configuracoes/associar-cartao/com-sucesso");
    };

    const inputClassName = isTablet ? 
    (isValidPhone ? 'inputTextMbWayLinckCardSteps' : 'inputTextMbWayLinckCardStepsInvalid') : ( isMobile ?
        (isValidPhone ? 'inputTextMbWayLinckCardStepsTablet' : 'inputTextMbWayLinckCardStepsTabletInvalid')
        :
        (isValidPhone ? 'inputTextMbWayLinckCardStepsMobile' : 'inputTextMbWayLinckCardStepsMobileInvalid'));

    const inputClassNameFocused  = isTablet ? 
    (isValidPhone ? 'inputTextMbWayLinckCardSteps focused' : 'inputTextMbWayLinckCardStepsInvalid focused') : ( isMobile ?
        (isValidPhone ? 'inputTextMbWayLinckCardStepsTablet focused' : 'inputTextMbWayLinckCardStepsTabletInvalid focused')
        :
        (isValidPhone ? 'inputTextMbWayLinckCardStepsMobile focused' : 'inputTextMbWayLinckCardStepsMobileInvalid focused'));


  return (  
    <>
    <Header/> 
    { isLoading ? 
        <GifAnim />
    :
    <div className={ isTablet ? "mainViewContainerLinckCardSteps" : ( isMobile ? "mainViewContainerLinckCardStepsTablet" : "mainViewContainerLinckCardStepsMobile")}>
        <div className={ isTablet ? 'firstTxtViewContainerLinckCardSteps' : ( isMobile ? 'firstTxtViewContainerLinckCardStepsTablet' : 'firstTxtViewContainerLinckCardStepsMobile') }>
            <Heading hasSaldo={false} />
            { !isTablet && (
                    <>
                    <div className={ isMobile ? 'mainImgViewLinckCardStepsTablet' : 'mainImgViewLinckCardStepsMobile'}>
                        <img src={ isTablet ? imgAddMbWay : ( isMobile ? imgAddMbWayTablet : imgAddMbWayMobile) } alt="imagem" className={ isMobile ? "mainImgAddMbWayLinckCardStepsTablet" : "mainImgAddMbWayLinckCardStepsMobile"} />
                    </div>
                    </>
                )}
            <div className={ isTablet ? 'secondMainContainerLinckCardSteps' : 'secondMainContainerLinckCardStepsMobile' }>
                <div className={ isTablet ? 'firstSubMainContainerLinckCardSteps'  : 'firstSubMainContainerLinckCardStepsMobile' }>
                    <div className={ isTablet ? 'secondTitleViewLinckCardSteps' : 'secondTitleViewLinckCardStepsMobile'}>
                        <span className={ isTablet ? 'textTitleRegular400LinckCardSteps' : 'textTitleRegular400LinckCardStepsMobile' }>Associar cartão por MB WAY</span>      
                    </div>
                    <div className={ isTablet ? 'txtSecondTitleViewLinckCardSteps' : 'txtSecondTitleViewLinckCardStepsMobile' }>
                        <div className='textSecondTitleViewLinckCardSteps'>Escreva o número de telemóvel associado ao seu MB WAY e siga os passos na aplicação.<br/>Para associar o cartão, confirme que o tem registado na app MB WAY.</div>
                    </div>
                    <div className={ isTablet ? 'textFormViewMbWayLinckCardSteps' : 'textFormViewMbWayLinckCardStepsMobile' }>
                        <div className='textWrapperMbWayLinckCardSteps'>
                            { (isFocused || phone.length) > 0 &&
                            <label className='label-focus'>Insira aqui o seu número de telemóvel</label>
                            }
                            <input 
                                className={ phone.length > 0 ? inputClassNameFocused : inputClassName }
                                type="text" 
                                placeholder={!isFocused ? 'EX.: 9XX XXX XXX *' : undefined}
                                value={phone}
                                onChange={(event) => {
                                    const input = event.target.value.replace(/\D/g, '');
                                    setPhone(input);
                                }}
                                maxLength={9}
                                onFocus={handleFocus}
                                onBlur={handleBlur}                            
                            />
                            { !isValidPhone &&
                                <div className='txtViewErrorInfoMbWayLinckCardSteps'>
                                    <div className='txtErrorInfoMbWayLinckCardSteps'><AiOutlineStop className='iconErrorInfoMbWayLinckCardSteps'/> Lamentamos, mas neste momento, não conseguimos validar o seu telemóvel. Por favor, tente mais tarde.</div>
                                </div>
                            } 
                        </div>
                    </div>
                    <div className={ isTablet ? 'btnsViewMbWayLinckCardSteps' : 'btnsViewMbWayLinckCardStepsMobile' }>
                        <CustomButton 
                            text={'Validar'} 
                            textColor={'#00214D'}
                            onPress={getAssociaCarteira} 
                            color={'#15D4B6'}
                            enabled={isValidPhoneNumber(phone)}
                            hasArrow
                            iconColor={'#00214D'}
                            iconType={'check'}
                            loading={isStartingLoadingDots}
                        />
                    </div> 
                </div>
                { isTablet && (
                    <>
                    <div className='mainImgViewLinckCardSteps'>
                        <img src={ isTablet ? imgAddMbWay : ( isMobile ? imgAddMbWayTablet : imgAddMbWayMobile) } alt="imagem" className="mainImgAddMbWayLinckCardSteps" />
                    </div>
                    </>
                )}
            </div>          
        </div>
    </div>
    }
    <Footer/> 
    </>
  )
}

export default OnboardingLinkCardStepMbWay;